var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.props.tag,_vm._g(_vm._b({tag:"component",class:_setup.cardRecipe(_setup.props, { className: _setup.props.className }),attrs:{"data-component":"CsCard","data-radius":_setup.props.radius,"data-variant-color":_setup.props.variantColor}},'component',_setup.attrs,false),_setup.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }